import { PropertyMapping, propertyMapping } from '@hakla/typed-forms'
import { ResourceViewModel } from '@/business/resource/interfaces/resource-view-model'
import { ResourceType } from '@/business/resource/interfaces/resource-type'
import { ResourceVariant } from '@/api/generated'

export interface ResourceDialogForm {
  location: string
  resource: ResourceViewModel
  type: ResourceType
  variant?: ResourceVariant
  variants?: ResourceVariant[]
}

export function resourceDialogFormMapping(): PropertyMapping<
  ResourceViewModel,
  ResourceDialogForm
> {
  return propertyMapping(({ generic }) => {
    return {
      location: generic('location'),
      resource: generic('resource'),
      type: generic('type'),
      variant: generic('variant').ignore(),
      variants: generic('variants').deserializeWith(value => value?.variants || []),
    }
  })
}
